import { useQueryClient } from '@tanstack/react-query'
import queryString from 'query-string'
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSetIsToastOpen } from 'src/app/Toast/redux/toast.actions'
import { DownloadFromEmailToastMessage } from 'src/app/Toast/Toast'
import { DownloadStatus } from 'src/enums'
import { connectedReplace } from 'src/navigation/Lnk'
import { homeUrl } from 'src/navigation/urls'
import { reportDownloadsQueries } from 'src/queries/reportDownloads/reportDownloads.queries'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

const Downloads: React.FC = () => {
  const location = useSelector(selectLocationFromState)
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const requestedReportIdRef = useRef<string>()
  const rawReportId = queryString.parse(location.search)?.reportId
  const reportId = typeof rawReportId === 'string' ? rawReportId : undefined

  useEffect(() => {
    const showErrorToast = () => {
      dispatch(
        createSetIsToastOpen(true, {
          toastMessage: (
            <DownloadFromEmailToastMessage status={DownloadStatus.Error} />
          ),
          failureColorScheme: true,
        }),
      )
    }

    if (reportId !== undefined && requestedReportIdRef.current !== reportId) {
      requestedReportIdRef.current = reportId
      void queryClient
        .fetchQuery(reportDownloadsQueries.detail(reportId))
        .then((response) => {
          if (response.reportDownload.fileUrl === undefined) {
            showErrorToast()
            return
          }

          dispatch(
            createSetIsToastOpen(true, {
              toastMessage: (
                <DownloadFromEmailToastMessage
                  status={DownloadStatus.Success}
                />
              ),
            }),
          )

          window.open(response.reportDownload.fileUrl, '_blank', 'noreferrer')
        })
        .catch(showErrorToast)
    }

    dispatch(connectedReplace(homeUrl()))
  }, [dispatch, queryClient, reportId])

  return null
}

export default Downloads
